import { useLocation, useNavigate } from "react-router-dom";
import CartBottomComponent from "../components/cart";
import { useMainContext } from "../context";
import { IoSearch } from "react-icons/io5";
import RestaurantHeader from "../pages/menu-page/components/header";
import { useMemo } from "react";
import { ROUTES } from "../routes";

const Layout = ({ children }) => {
  const { showCart, restaurantId, search, setSearch } = useMainContext();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const isCartPage = pathname === ROUTES.CART;
  const isHome = pathname === ROUTES.RESTAURANT(restaurantId);
  const isOrdersPage = pathname === ROUTES.ORDERS;

  const tabItems = useMemo(
    () => [
      {
        label: "Cardápio",
        isActive: isHome,
        onClick: () => navigate(ROUTES.RESTAURANT(restaurantId)),
      },
      {
        label: "Pedidos",
        isActive: isOrdersPage,
        onClick: () => navigate(ROUTES.ORDERS),
      },
    ],
    [restaurantId, isHome, isOrdersPage, navigate],
  );

  return (
    <>
      <div className="grid xl:grid-cols-3 xl:h-screen">
        <RestaurantHeader />

        <div className="xl:col-span-2 relative xl:h-screen xl:overflow-y-auto flex flex-col">
          <nav className="sticky w-full top-0 flex border-b border-gray-200 bg-white shadow z-10">
            {tabItems.map((item) => (
              <button
                key={item.label}
                onClick={item.onClick}
                className={[
                  "px-4 py-4 md:px-8 font-bold border-b-4 transition-colors",
                  item.isActive
                    ? "text-primary-500 border-primary-500"
                    : "text-gray-500 border-transparent hover:text-gray-800 hover:border-gray-800",
                ].join(" ")}
              >
                {item.label}
              </button>
            ))}

            <span className="sm:grow" />

            {isHome && (
              <div className="grow sm:grow-0 flex items-center pr-4">
                <div className="flex items-center">
                  <label htmlFor="search">
                    <IoSearch size={20} />
                  </label>
                  <input
                    id="search"
                    type="text"
                    className="rounded-md w-full max-w-56 px-4 py-2 focus:outline-none focus:border-transparent text-sm"
                    placeholder="Buscar no cardápio..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>
              </div>
            )}
          </nav>

          <div className="h-full flex flex-col">{children}</div>
        </div>
      </div>

      {!isCartPage && showCart && <CartBottomComponent />}
    </>
  );
};

export default Layout;
